// extracted by mini-css-extract-plugin
module.exports = {"root":"rwFpS","left":"_2p3Pk","right":"_1gJJs","small":"_12mld","normal":"_35_cx"};